export const locales = ["de"] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = "de";

// DACH country codes for auto-detection
export const dachLocales = ["de", "de-DE", "de-AT", "de-CH"];
